import { Logger } from '@aloft/toolkit-shared';
import { captureException, setSentryUser } from '@aloft/toolkit-shared/src/sentry/frontend.ts';

class TKFrontendLogger implements Logger {
  static singleton: TKFrontendLogger;

  static getLogger(): TKFrontendLogger {
    if (!TKFrontendLogger.singleton) {
      TKFrontendLogger.singleton = new TKFrontendLogger();
    }
    return TKFrontendLogger.singleton;
  }

  private _logger: any;
  constructor() {
    this._logger = console;
  }

  child: () => Logger = () => this._logger;

  public info(info: any, meta?: string) {
    this._logger.info({ info, meta });
  }

  public warn(info: any, meta?: string) {
    this._logger.warn({ info, meta });
  }

  public error(info: any, meta?: string) {
    captureException(info, { meta });
    this._logger.error({ info, meta });
  }

  public fatal(info: any, meta?: string) {
    captureException(info, { meta });
    this._logger.error({ info, meta });
  }

  public debug(info: any, meta?: string): void {
    this._logger.debug({ info, meta });
  }
}

export function logger(): TKFrontendLogger {
  return TKFrontendLogger.getLogger();
}

type LoggerIdentifier = {
  name?: string;
  uid?: string;
  sessionID?: string;
  email?: string;
  env: string;
  isTestUser: boolean;
};

export function setLogIdentifier(identifier: LoggerIdentifier) {
  setSentryUser(identifier);
}

export function initLogger() {
  logger().info('Logger initialized');
}
